import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  href?: string;
  onClick?: () => void;
}
export function Button({
  children,
  className = '',
  fullWidth = false,
  href,
  onClick
}: ButtonProps) {
  const classes = `
    relative overflow-hidden rounded-xl bg-accent-gradient px-8 py-4
    font-heading text-lg font-bold text-[#0f1724] shadow-[0_0_20px_rgba(34,211,238,0.3)]
    transition-shadow hover:shadow-[0_0_30px_rgba(34,211,238,0.5)] inline-block text-center no-underline
    ${fullWidth ? 'w-full' : ''}
    ${className}
  `;
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={classes} data-id="element-138">
        <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-139">
          {children}
        </span>
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={classes} onClick={onClick} data-id="element-140">
      <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-141">
        {children}
      </span>
    </motion.button>;
}